module.exports = {
  none: '0',
  vsm:'16px',
  sm: '34px',
  md: '52px',
  lg: '100px',
  full: '9999px',
}
